import { render, staticRenderFns } from "./student-quote-info.vue?vue&type=template&id=39cf7dda&scoped=true&"
import script from "./student-quote-info.vue?vue&type=script&lang=js&"
export * from "./student-quote-info.vue?vue&type=script&lang=js&"
import style0 from "./student-quote-info.vue?vue&type=style&index=0&id=39cf7dda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cf7dda",
  null
  
)

export default component.exports